import { LIST_ROLES_CALL_CENTER, ROLE } from '@/shared/config';
import _ from 'lodash';

const { localStorage } = global.window;

const LOCAL_DATA = {
  token: '',
  socketId: '',
  originalToken: '',
};

const auth = {
  getOriginalToken: () => LOCAL_DATA.originalToken,
  setOriginalToken: (token: string) => {
    LOCAL_DATA.originalToken = token;
  },

  getSocketId: () => LOCAL_DATA.socketId,
  setSocketId: (id: string) => {
    LOCAL_DATA.socketId = id;
  },

  // TODO(ts): typed as the share-link payload once Apollo domains land
  saveShareData: (shareData: any) => {
    _.assign(localStorage, { ...shareData });
  },

  // TODO(ts): typed as the `me` query response once Apollo domains land
  setUserData: (me: any) => {
    localStorage.isSuccess = !_.isEmpty(me);
    localStorage.login = JSON.stringify(me);
    localStorage.userId = me?.id;
    localStorage.username = me?.username;
    localStorage.firstName = me?.firstName;
    localStorage.lastName = me?.lastName;
    localStorage.email = me?.email;
    localStorage.roles = JSON.stringify(me?.roles);
    localStorage.willViewTutorialLater = me?.willViewTutorialLater;
    localStorage.willShowWhatNewPopup = me?.willViewTutorialLater;
    localStorage.canUseAiViewer = me?.canUseAiViewer;
    localStorage.isTestAccount = me?.isTestAccount;
    localStorage.isEmailVerified = me?.isEmailVerified;
  },

  token: () => LOCAL_DATA.token,

  setToken: (token: string) => {
    LOCAL_DATA.token = token;
  },

  userId: () => localStorage.userId,

  firstName: () => localStorage.firstName,

  setFirstName: (name: string) => {
    localStorage.firstName = name;
  },

  lastName: () => localStorage.lastName,

  setLastName: (name: string) => {
    localStorage.lastName = name;
  },

  username: () => localStorage.username,

  email: () => {
    if (localStorage.email === 'null') return null;
    return localStorage.email;
  },

  setEmail: (email: string) => {
    localStorage.email = email;
  },

  role: () => localStorage.role,

  isEmailVerified: () => localStorage.isEmailVerified === 'true',

  shouldChangePassword: () => localStorage.shouldChangePassword === 'true',

  isRemindVerifyEmailLater: () => localStorage.isRemindVerifyEmailLater === 'true',

  setIsRemindVerifyEmailLater: (isRemindVerifyEmailLater: boolean) => {
    localStorage.isRemindVerifyEmailLater = isRemindVerifyEmailLater;
  },

  setIsEmailVerified: (isEmailVerified: boolean) => {
    localStorage.isEmailVerified = isEmailVerified;
  },

  getWillViewTutorialLater: () =>
    localStorage.willViewTutorialLater && localStorage.willViewTutorialLater !== 'undefined'
      ? localStorage.willViewTutorialLater
      : 'false',

  saveWillViewTutorialLater: (willViewTutorialLater: boolean) => {
    localStorage.willViewTutorialLater = willViewTutorialLater;
  },

  getWillShowWhatNewPopup: () =>
    localStorage.willShowWhatNewPopup && localStorage.willShowWhatNewPopup !== 'undefined'
      ? localStorage.willShowWhatNewPopup
      : 'false',

  saveWillShowWhatNewPopup: (willShowWhatNewPopup: boolean) => {
    localStorage.willShowWhatNewPopup = willShowWhatNewPopup;
  },

  setUserFacilityId: (facilityId: string) => {
    localStorage.facilityId = facilityId;
  },

  userFacilityId: () => localStorage.facilityId,

  selectedFacilityId: () => localStorage.selectedFacilityId,

  // TODO(ts): typed as the facility list payload once Apollo domains land
  setUserSupportFacilities: (supportFacilities: any[]) => {
    const reducedSupportFacilities = _.map(supportFacilities, (supportFacility) => ({
      id: supportFacility?.id,
      // *: Hide Biocare Cardiac temporarility
      // canUseBiocareCardiac: supportFacility?.canUseBiocareCardiac,
      canViewFlaggedStudies: supportFacility?.canViewFlaggedStudies,
    }));
    localStorage.userSupportFacilities = JSON.stringify(reducedSupportFacilities);
  },

  userSupportFacilities: () =>
    localStorage.userSupportFacilities ? JSON.parse(localStorage.userSupportFacilities) : [],

  // TODO(ts): typed as the facility record once Apollo domains land
  setSelectedFacilityLocalStorage: (selectedFacilityLocalStorage: any) => {
    localStorage.selectedFacilityLocalStorage = JSON.stringify(selectedFacilityLocalStorage);
  },

  selectedFacilityLocalStorage: () =>
    localStorage.selectedFacilityLocalStorage
      ? JSON.parse(localStorage.selectedFacilityLocalStorage)
      : undefined,

  setUserGroupId: (groupId: string) => {
    localStorage.groupId = groupId;
  },

  userGroupId: () => localStorage.groupId,

  setIsShowLatestVersionModal: (isShowLatestVersionModal: boolean) => {
    localStorage.isShowLatestVersionModal = isShowLatestVersionModal;
  },

  isShowLatestVersionModal: () => localStorage.isShowLatestVersionModal === 'true',

  setIsCheckedNotificationReports: (isCheckedNotificationReports: boolean) => {
    localStorage.isCheckedNotificationReports = isCheckedNotificationReports;
  },

  isCheckedNotificationReports: () => localStorage.isCheckedNotificationReports,

  setIsCheckedViewEcgGuideLineNoti: (isCheckedViewEcgGuideLineNoti: boolean) => {
    localStorage.isCheckedViewEcgGuideLineNoti = isCheckedViewEcgGuideLineNoti;
  },

  isCheckedViewEcgGuideLineNoti: () => localStorage.isCheckedViewEcgGuideLineNoti,

  setIsCheckedNotificationStudies: (isCheckedNotificationStudies: boolean) => {
    localStorage.isCheckedNotificationStudies = isCheckedNotificationStudies;
  },

  isCheckedNotificationStudies: () => localStorage.isCheckedNotificationStudies,

  setIsCheckedNotiCommonQuestions: (isCheckedNotiCommonQuestions: boolean) => {
    localStorage.isCheckedNotiCommonQuestions = isCheckedNotiCommonQuestions;
  },

  isCheckedNotiCommonQuestions: () => localStorage.isCheckedNotiCommonQuestions,

  // *: Marketing banner
  isShowMarketingBanner: () => localStorage.isShowMarketingBanner,

  setIsShowMarketingBanner: (isShowMarketingBanner: boolean) => {
    localStorage.isShowMarketingBanner = isShowMarketingBanner;
  },

  canUseAiViewer: () => localStorage.canUseAiViewer === 'true',

  isTestAccount: () => localStorage.isTestAccount,

  isCallCenterTechnician: () => {
    try {
      return localStorage.roles
        ? _.includes(JSON.parse(localStorage.roles), ROLE.CALL_CENTER_TECHNICIAN)
        : false;
    } catch (error) {
      console.error('Failed to get isCallCenterTechnician from localStorage: ', error);
      return false;
    }
  },

  isCallCenterQA: () => {
    try {
      return localStorage.roles
        ? _.includes(JSON.parse(localStorage.roles), ROLE.CALL_CENTER_QA)
        : false;
    } catch (error) {
      console.error('Failed to get isCallCenterQA from localStorage: ', error);
      return false;
    }
  },

  isCallCenterSupervisor: () => {
    try {
      return localStorage.roles
        ? _.includes(JSON.parse(localStorage.roles), ROLE.CALL_CENTER_SUPERVISOR)
        : false;
    } catch (error) {
      console.error('Failed to get isCallCenterSupervisor from localStorage: ', error);
      return false;
    }
  },

  isCallCenterQaLeader: () => {
    try {
      return localStorage.roles
        ? _.includes(JSON.parse(localStorage.roles), ROLE.CALL_CENTER_QA_LEADER)
        : false;
    } catch (error) {
      console.error('Failed to get isCallCenterQaLeader from localStorage: ', error);
      return false;
    }
  },

  isCallCenter: () => {
    try {
      return localStorage.roles
        ? _.intersection(JSON.parse(localStorage.roles), LIST_ROLES_CALL_CENTER).length > 0
        : false;
    } catch (error) {
      console.error('Failed to get isCallCenter from localStorage: ', error);
      return false;
    }
  },

  logout: () => {
    localStorage.clear();
  },

  logoutExceptUsername: () => {
    const { firstName, lastName } = localStorage;
    localStorage.clear();
    localStorage.firstName = firstName;
    localStorage.lastName = lastName;
  },
};

export default auth;
